import { getRequiredOnboardingSkuId } from 'pricing-pages-lib/utils/requiredOnboardingUtils';
import { getProductBasedOfferId } from 'pricing-pages-lib/utils/offerUtils';
import { getProductVersion } from './productsUtils';
export const getProductBasedOfferIdsWithMandatorySku = (state, {
  skuIds
}) => {
  const offerIds = [];
  skuIds.filter(skuId => getProductVersion(state, {
    skuId
  }).skuId === skuId).forEach(skuId => {
    const onboardingSkuId = getRequiredOnboardingSkuId(state, {
      skuId
    });
    const productBasedOfferId = getProductBasedOfferId(state, {
      skuId
    });

    if (productBasedOfferId) {
      offerIds.push(productBasedOfferId);
    }

    if (onboardingSkuId) {
      const onboardingOfferId = getProductBasedOfferId(state, {
        skuId: onboardingSkuId
      });
      if (onboardingOfferId) offerIds.push(onboardingOfferId);
    }
  });
  return offerIds;
};